// blog data

export const Blogs = [
    {
        id:1,
        name:"World Happiness Machine Learning Website.The platform is designed to aid researchers and policymakers in understanding the determinants of happiness globally.",
        tags:["machine learning", "data analysis", "visualization", "happiness", "prediction"],
        date:"13 Nov, 2023",
        imgSrc:"https://raw.githubusercontent.com/naveenkumarsekar-dev/happinesspredictor-repo/main/HappinessPredictor%20Images/Screenshot%202024-11-17%20153833.png",
        link:"https://happinesspredictor.pythonanywhere.com/"
    },
    {
        id:2,
        name:"Inquisitive AI Web Application. Inquisitive AI is a powerful Streamlit application,It leverages Google Generative AI to automatically generate insightful questions from input text. (MULTI LANGUAGE QUESTION GENERATOR)",
        tags:["AIPoweredLearning","QuestionGeneration","GoogleGenerativeAI"],
        date:"5 Jan, 2024",
        imgSrc:"https://raw.githubusercontent.com/naveenkumarsekar-dev/inquisitive-streamlit-app/ea4c169233d55e33658e210b3068b4ac6bca44df/Output_Images/english.png",
        link:"https://inquisitive.streamlit.app"
    },
    {
        id:3,
        name:"Full-Stack Inventory Management with React, Express, and MongoDB. It enables efficient sales tracking, user management, and the generation of printable bills, providing a seamless solution for businesses to manage their operations.",
        tags:["inventorymanagement","inventorytracking","salestracking"],
        date:"6 July, 2024",
        imgSrc:"https://raw.githubusercontent.com/naveenkumarsekar-dev/inventory_management_mern/main/Inventory%20Management%20Images/Screenshot%202024-11-17%20161705.png",
        link:"https://inventory-management-mern.vercel.app"
    },
    {
        id:4,
        name:"ChatGenie: AI-Powered Chatbot with GPT-3 Integration. ChatGenie is powered by OpenAI's GPT-3 model, designed to engage users in intelligent, natural conversations",
        tags:["aichatbot","openai","webchatbot"],
        date:"26 May, 2023",
        imgSrc:"https://raw.githubusercontent.com/naveenkumarsekar-dev/chatbot-project/03825846e362ae1fb3d73ead3d647a2d91878d65/chatbot.png",
        link:"https://github.com/naveenkumarsekar-dev/chatbot-project"
    },
    // {
    //     id:5,
    //     name:"What is Higher Order Component (HOC) in React JS?",
    //     tags:["react","reactJS","web-development"],
    //     date:"3 Feb, 2021",
    //     imgSrc:"https://codebucks.hashnode.dev/_next/image?url=https%3A%2F%2Fcdn.hashnode.com%2Fres%2Fhashnode%2Fimage%2Fupload%2Fv1625295480148%2FlyKj8bpHK.jpeg%3Fw%3D1600%26h%3D840%26fit%3Dcrop%26crop%3Dentropy%26auto%3Dcompress%2Cformat%26format%3Dwebp&w=1920&q=75",
    //     link:"https://codebucks.hashnode.dev/what-is-higher-order-component"
    // },
    // {
    //     id:6,
    //     name:"How to implement Pagination Component in React from scratch",
    //     tags:["react","css"],
    //     date:"5 Jan, 2021",
    //     imgSrc:"https://codebucks.hashnode.dev/_next/image?url=https%3A%2F%2Fcdn.hashnode.com%2Fres%2Fhashnode%2Fimage%2Fupload%2Fv1625240050668%2FGAya9b0XK.png%3Fw%3D1600%26h%3D840%26fit%3Dcrop%26crop%3Dentropy%26auto%3Dcompress%2Cformat%26format%3Dwebp&w=1920&q=75",
    //     link:"https://codebucks.hashnode.dev/pagination-in-react"

    // },
   
    // {
    //     id:7,
    //     name:"What is Redux ? Simply Explained!",
    //     tags:["react","redux","javascript"],
    //     date:"16 May, 2021",
    //     imgSrc:"https://res.cloudinary.com/practicaldev/image/fetch/s--ZY1EK-Eo--/c_imagga_scale,f_auto,fl_progressive,h_420,q_auto,w_1000/https://dev-to-uploads.s3.amazonaws.com/uploads/articles/bcz1u90oq3prr5fga3fs.png",
    //     link:"https://dev.to/codebucks/what-is-redux-simply-explained-2ch7"
    // },
    // {
    //     id:8,
    //     name:"How to create Sidebar navigation menu in ReactJS with react router and framer-motion",
    //     tags:["react","framer-motion","styled-components"],
    //     date:"26 May, 2021",
    //     imgSrc:"https://res.cloudinary.com/practicaldev/image/fetch/s--rv4I8UwE--/c_imagga_scale,f_auto,fl_progressive,h_420,q_auto,w_1000/https://dev-to-uploads.s3.amazonaws.com/uploads/articles/0a9h50milhlf1us6mn4a.png",
    //     link:"https://dev.to/codebucks/build-sidebar-navigation-menu-in-reactjs-with-react-router-and-framer-motion-for-cool-page-transition-effects-4bc3"
    // },
  
] 